package com.mshopsas.enterprise.aiw.scan.data.scanner

enum class ScannerType {
    DATA_MATRIX,
    EAN13,
    EAN8,
    QR,
    UNKNOWN
}
